import { render, staticRenderFns } from "./DevImageView.vue?vue&type=template&id=2e97fe6e&scoped=true&"
import script from "./DevImageView.vue?vue&type=script&lang=js&"
export * from "./DevImageView.vue?vue&type=script&lang=js&"
import style0 from "./DevImageView.vue?vue&type=style&index=0&id=2e97fe6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97fe6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VImg,VSpacer,VToolbar})
